import graphqlClient from "../../../apollo";

class UserConfigurationProvider {

    getUserConfiguration(forceRefresh = false) {
        return graphqlClient.query({
            query: require('./gql/userConfigurationGet.graphql'),
            fetchPolicy: forceRefresh ? "network-only" : "cache-first"
        })
    }

    getDepositoIdFromCache() {
        try {
            const data = graphqlClient.readQuery({
                query: require('./gql/userConfigurationGet.graphql')
            });
            if (data && data.userConfigurationGet && data.userConfigurationGet.depositoIdSeleccionado) {
                return data.userConfigurationGet.depositoIdSeleccionado;
            }
            return null;
        } catch (error) {
            // Si no hay datos en el cache, retornar null
            return null;
        }
    }

    updateUserConfiguration(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/userConfigurationUpdate.graphql'),
            variables: form,
            refetchQueries: [{ query: require('./gql/userConfigurationGet.graphql') }],
            awaitRefetchQueries: true
        })
    }

}

export default new UserConfigurationProvider()

